/**
 * Created by Administrator on 2018/7/2.
 */
import { post,get } from './../utils/axios'
export function login(params) {
  return post('base/login', params, BASE.base2)
}
//获取模板
export function getFormTemp(params) {
  return get('form/getFormTemp', params)
}
//提交模板
export function insertForm(params) {
  return post('form/insertForm', params)
}
//获取详情
export function getFormDetail(params) {
  return get('form/getFormDetail', params)
}
//编辑保存：
export function updateForm(params) {
  return post('form/updateForm', params)
}
//列表
export function getFormList(params) {
  return post('form/getFormList', params)
}
//删除列表
export function delForm(params) {
  return get('form/delForm', params)
}
//根据关键字搜索企业
export function accessOutApi(params) {
  return get('form/accessOutApi', params)
}
// 根据企业名称搜索企业详细信息
export function accessOutApi1(params) {
  return get('form/accessOutApi1', params)
}
//提交
export function submitForm(params) {
  return get('form/submitForm', params)
}
//  退回
export function revoForm(params) {
  return get('form/revoForm', params)
}

//获取用户对应的菜单
export function getUserMenu(params) {
  return get('auth/getUserMenu',params, BASE.base2)
}

//获取当前登录人的按钮
export function getUserButton(params) {
  return get('auth/getUserButton',params, BASE.base2)
}

//修改密码
export function updatePwd(params) {
  return post('base/updatePwd',params, BASE.base2)
}

//获取资讯列表：
export function getInformationDetail(params) {
  return post('collection/getInformationDetail',params)
}
//预警接口
export function getWarningList(params) {
  return post('collection/getWarningList',params)
}
//今日提醒
export function getRemindList(params) {
  return post('collection/getRemindList',params)
}
//图标
export function getIcon(params) {
  return get('collection/getIcon',params)
}

// 根据id获取咨询详情
export function getInformationById(params) {
  return get('collection/getInformationById',params)
}
//获取今日提醒详情
export function getRemindDetail(params) {
  return get('collection/getRemindDetail',params)
}
//预警详情
export function getWarningDetail(params) {
  return get('collection/getWarningDetail',params)
}
// 获取模板下拉
export function getUserTemp(params) {
  return get('auth/getUserTemp',params, BASE.base2)
}



// WEBPACK FOOTER //
// ./src/utils/api.js